import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCode2Line = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.68313 8.30507C7.94829 8.62329 7.90527 9.09621 7.58705 9.36136L4.4215 11.9991L7.58713 14.6376C7.90532 14.9028 7.94826 15.3757 7.68306 15.6939C7.41785 16.0121 6.94492 16.0551 6.62674 15.7898L2.7698 12.5751C2.59883 12.4326 2.49998 12.2215 2.5 11.9989C2.50002 11.7763 2.59889 11.5653 2.76989 11.4228L6.62683 8.20899C6.94505 7.94383 7.41797 7.98684 7.68313 8.30507Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.8164 8.30507C17.0816 7.98684 17.5545 7.94383 17.8727 8.20899L21.7296 11.4228C21.9006 11.5653 21.9995 11.7763 21.9995 11.9989C21.9996 12.2215 21.9007 12.4326 21.7297 12.5751L17.8728 15.7898C17.5546 16.0551 17.0817 16.0121 16.8165 15.6939C16.5513 15.3757 16.5942 14.9028 16.9124 14.6376L20.078 11.9991L16.9125 9.36136C16.5943 9.09621 16.5512 8.62329 16.8164 8.30507Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.0775 4.22505C15.4668 4.36661 15.6676 4.79693 15.526 5.18621L10.3828 19.3296C10.2412 19.7189 9.8109 19.9197 9.42162 19.7781C9.03235 19.6366 8.83154 19.2063 8.9731 18.817L14.1163 4.67358C14.2579 4.2843 14.6882 4.08349 15.0775 4.22505Z",
			fill: "currentColor"
		})
	]
});
export default SvgCode2Line;
